import { useLocation } from "react-router-dom"
import { useEffect } from "react"

export default function useLocationChange (callback?: Function) {
    const location = useLocation()
    const key = location.key
    useEffect(() => {
        if (!callback) return
        callback()
    }, [key, callback])
  }
